import React from 'react';
import { Box, Text } from '@mantine/core';

interface PageHeaderProps {
  title: string;
  children?: React.ReactNode;
}

export default function PageHeader({ title, children }: PageHeaderProps) {
  return (
    <Box py="8px">
      <Text pl="4" fz="md">
        {title}
      </Text>
      {children}
    </Box>
  );
}
